<template>
  <div id="container">
    <div class="box">
      <div class="box_one" style="margin-bottom:5px"> 
        <cont-top/>
      </div> 

      <div  style="margin-bottom:5px;background-color:#000"> 
        <cont-two/>
      </div>

      <div  style="margin-bottom:5px;background-color:#000"> 
        <cont-three/>
      </div>

      <div class="box_bottom" > 
        <cont-bottom/>
      </div> 

    </div>
    

  </div>
</template>

<script>
// @ is an alias to /src
// import ContOne from '@/'

import ContTop from '@/views/ShopMallOnlinePages/Cont_top'
import ContTwo from '@/views/ShopMallOnlineComponent/cont_two'
import ContThree from '@/views/ShopMallOnlineComponent/cont_three'
// import ContFour from '@/views/BrandComponent/cont_four'
// import ContFive from '@/views/BrandComponent/cont_five'
// import ContSix from '@/views/BrakeComponent/cont_six'
// import ContSeven from '@/views/BrakeComponent/cont_seven'
import ContBottom from '@/views/Components/Cont_bottom'

export default {
  components: {
    ContTop ,
    ContTwo ,
    ContThree  ,
    // ContFour ,
    // ContFive ,
    // ContSix ,
    // ContSeven ,
    ContBottom
  } ,
  methods : {
    jumpClick () {

    }
  } ,
  mounted (){
  }
}
</script>

<style lang="stylus" scoped>
#container
  background-color : #000
  .box_one 
    width: 100%;
    background-repeat : no-repeat 
    background-size : cover
    background-color #000


  .box_bottom
    width: 100%;
    background-color #000


.box 
  width: 1003px;
  margin: 0 auto;
  background-color:#fff
</style>